"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _superagent = _interopRequireDefault(require("superagent"));
var _superagentLegacyiesupport = _interopRequireDefault(require("superagent-legacyiesupport"));
var _classnames = _interopRequireDefault(require("classnames"));
var _dateHelper = _interopRequireDefault(require("static-site-generator-shared/plugins/lib/dateHelper"));
var _helpers = _interopRequireDefault(require("static-site-generator-shared/plugins/lib/helpers"));
var _tracker = _interopRequireDefault(require("static-site-generator-shared/plugins/lib/tracker"));
var _engineHelper = _interopRequireDefault(require("../engineHelper"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class FlightTypeahead extends _react.default.Component {
  constructor(props) {
    super(props);
    this._isMounted = false;
    this.state = {
      showDropdown: false,
      chosenFlight: false,
      flightText: '',
      interacted: false,
      flights: {}
    };
    this.clearText = this.clearText.bind(this);
    this.resetFlight = this.resetFlight.bind(this);
    this.showDropdown = this.showDropdown.bind(this);
    this.blurDropdown = this.blurDropdown.bind(this);
    this.hideDropdown = this.hideDropdown.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.showResults = this.showResults.bind(this);
  }
  componentDidMount() {
    this._isMounted = true;
    window._flightSearchDelay = window._flightSearchDelay || {};
    this.focusInput();
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (nextState.interacted === true && this.state.interacted === false) this.interactedWith();
    if (_engineHelper.default.checkUpdated(nextState.flightText, this.state.flightText)) return true;
    if (_engineHelper.default.checkUpdated(nextState.flights, this.state.flights)) return true;
    if (_engineHelper.default.checkUpdated(nextState.showDropdown, this.state.showDropdown)) return true;
    if (_engineHelper.default.checkUpdated(nextState.chosenFlight, this.state.chosenFlight)) return true;
    if (_engineHelper.default.checkUpdated(nextState.interacted, this.state.interacted)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.name, this.props.name)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.activeFlight, this.props.activeFlight)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.placeHolder, this.props.placeHolder)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.searchTimeout, this.props.searchTimeout)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.minTextLimit, this.props.minTextLimit)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.scrollResults, this.props.scrollResults)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.autoFocus, this.props.autoFocus)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.onChange, this.props.onChange)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.customChosenText, this.props.customChosenText)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.id, this.props.id)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.flightFieldInteraction, this.props.flightFieldInteraction)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.departure, this.props.departure)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.location, this.props.location)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.cookieName, this.props.cookieName)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.trackingPrefix, this.props.trackingPrefix)) return true;
    return false;
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.state.chosenFlight !== prevState.chosenFlight && this.props.onChange) this.props.onChange(this.state.chosenFlight, true);else if (_engineHelper.default.checkUpdated(prevState.flightText, this.state.flightText)) this.shouldMakeSearch();
  }
  track(name, value = '1') {
    const {
      trackingPrefix
    } = this.props;
    try {
      _tracker.default.track(trackingPrefix + name, value);
    } catch (e) {
      // console.log('Didn\'t Track')
    }
  }
  focusInput() {
    const {
      autoFocus,
      flightSearchInputRef = {}
    } = this.props;
    if (!autoFocus || !flightSearchInputRef.current) return;
    flightSearchInputRef.current.focus();
  }
  clearText() {
    this.resetFlight(true);
    this.track('cleared_text');
  }
  resetFlight(resetText = false) {
    const {
      cookieName
    } = this.props;
    _engineHelper.default.engineCookies(cookieName, '');
    this.setState({
      flights: {},
      chosenFlight: false,
      showDropdown: false,
      flightText: resetText ? '' : this.state.flightText
    });
  }
  handleKeyDown(e) {
    const {
      scrollResults
    } = this.props;
    let highlighted = _helpers.default.$('#flightSearch .dropdown-menu li.active');
    let nextHighlight = highlighted;
    switch (e.keyCode) {
      case 27:
        // Escape key
        this.hideDropdown();
        e.preventDefault();
        e.stopPropagation();
        return;
      case 38:
      case 40:
        if (e.keyCode === 38) {
          // Up key
          if (highlighted) nextHighlight = highlighted.previousSibling;
          if (!nextHighlight) nextHighlight = _helpers.default.$('#flightSearch .dropdown-menu li:last-child');
        }
        if (e.keyCode === 40) {
          // Down key
          if (highlighted) nextHighlight = highlighted.nextSibling;
          if (!nextHighlight) nextHighlight = _helpers.default.$('#flightSearch .dropdown-menu li:first-child');
        }
        if (nextHighlight && highlighted !== nextHighlight) {
          if (highlighted) highlighted.classList.remove('active');
          nextHighlight.classList.add('active');
          if (scrollResults) this.scrollParentToChild(nextHighlight, e.keyCode === 40);
        }
        break;
      case 13:
        // Enter key
        _helpers.default.$('#flightSearch .dropdown-menu li.active a').click();
        e.preventDefault();
        e.stopPropagation();
    }
  }
  scrollParentToChild(child, down) {
    const parent = _helpers.default.$('#flightSearch .dropdown-menu');
    const parentRect = parent.getBoundingClientRect();
    const parentHeight = parent.clientHeight;
    const childRect = child.getBoundingClientRect();
    const isViewable = childRect.top >= parentRect.top && childRect.bottom <= parentRect.bottom;

    // if you can't see the child try to scroll parent
    if (!isViewable) {
      if (down) parent.scrollTop = childRect.top + parent.scrollTop - parentHeight - child.clientHeight;else parent.scrollTop = childRect.top + parent.scrollTop - parentRect.top;
    }
  }
  handleChange(e) {
    let {
      flightText,
      chosenFlight
    } = this.state;
    const {
      cookieName
    } = this.props;
    const {
      value
    } = e.target;
    if (this.notMeetingMinLengthRequirement(value) || value !== flightText && flightText) {
      chosenFlight = false;
      _engineHelper.default.engineCookies(cookieName, '');
    }
    this.setState({
      flightText: value,
      chosenFlight,
      interacted: true,
      showDropdown: !this.notMeetingMinLengthRequirement(value)
    });
  }
  shouldMakeSearch() {
    const {
      location,
      departure
    } = this.props;
    if (!location || !departure) return;
    this.lookupFlights();
  }
  lookupFlights() {
    const {
      id,
      searchTimeout
    } = this.props;
    window._flightSearchDelay[id + 'flight'] = setTimeout(() => {
      this.clearTimer();
      try {
        _superagent.default.get(this.makeRequestURL()).use(_superagentLegacyiesupport.default).end(this.showResults);
      } catch (e) {
        // console.log('Flitgh typeahead failed to search', e)
      }
    }, searchTimeout);
  }
  showResults(err, res) {
    if (!this._isMounted) return;
    if (err) return this.resetFlight();
    if (res && res.body) {
      this.setState({
        flights: res.body
      });
    }
  }
  notMeetingMinLengthRequirement(value) {
    const {
      minTextLimit
    } = this.props;
    const valueLength = value ? value.replace(/\s?/, '').length : 0;
    if (!value || valueLength >= 1) return false;
    return valueLength < minTextLimit;
  }
  clearTimer() {
    const {
      id
    } = this.props;
    clearInterval(window._flightSearchDelay[id + 'flight']);
    window._flightSearchDelay = {};
  }
  correctDate() {
    const {
      departure
    } = this.props;
    return typeof departure === 'object' ? departure : new Date(departure);
  }
  makeRequestURL() {
    const {
      flightEndpoint,
      location
    } = this.props;
    let {
      flightText = '',
      chosenFlight
    } = this.state;
    if (chosenFlight) flightText = chosenFlight;
    const departDate = _dateHelper.default.nativeDateToIso(this.correctDate());
    const url = [flightEndpoint + 'search?query=' + flightText, 'location=' + location, 'departDate=' + departDate];
    this.track('searching', JSON.stringify({
      query: flightText,
      location,
      departDate
    }));
    return url.join('&');
  }
  handleClick(e) {
    const {
      cookieName,
      customChosenText
    } = this.props;
    const {
      flights
    } = this.state;
    const flightNumber = e.target.getAttribute('data-flight');
    const flightIndex = e.target.getAttribute('data-flight-index');
    let flightText = flightNumber;
    if (customChosenText) {
      const customFlightText = customChosenText(flights[flightIndex]);
      if (customFlightText) flightText = customFlightText;
    }
    _engineHelper.default.engineCookies(cookieName, flightNumber);
    const chosenFlight = flights.filter(f => f.flight.code === flightNumber);
    this.setState({
      chosenFlight: chosenFlight.length ? chosenFlight[0] : false,
      flightText,
      showDropdown: false
    });
    this.trackChosenFlight(flightNumber, flightIndex);
    e.preventDefault();
  }
  trackChosenFlight(chosenFlight, flightIndex) {
    const {
      flights
    } = this.state;
    if (!chosenFlight) this.track('cant_find_flight');else {
      this.track('total_and_chosen_position', flights.length + ' - ' + flightIndex);
      this.track('chosen', chosenFlight);
    }
  }
  showDropdown() {
    setTimeout(() => {
      this.setState({
        showDropdown: true
      });
    }, 100);
  }
  blurDropdown() {
    setTimeout(this.hideDropdown, 300);
  }
  hideDropdown() {
    this.setState({
      showDropdown: false
    });
  }
  interactedWith() {
    const {
      flightFieldInteraction
    } = this.props;
    this.track('interacted');
    if (typeof flightFieldInteraction === 'function') flightFieldInteraction();
  }
  makeFlightTypeahead() {
    const {
      flights
    } = this.state;
    if (!flights.length) return null;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "dropdown-menu",
      onFocus: this.showDropdown
    }, /*#__PURE__*/_react.default.createElement("ul", null, flights.map((flight, key) => /*#__PURE__*/_react.default.createElement("li", {
      key: key
    }, /*#__PURE__*/_react.default.createElement("a", {
      "data-flight-index": key,
      "data-flight": flight.flight.code,
      href: "#",
      onClick: this.handleClick
    }, flight.typeahead)))));
  }
  haveFlights() {
    const {
      flightText,
      showDropdown,
      chosenFlight
    } = this.state;
    if (this.notMeetingMinLengthRequirement(flightText)) return false;
    const {
      flights
    } = this.state;
    return flights.length > 0 && showDropdown && !chosenFlight;
  }
  render() {
    const {
      name,
      placeHolder,
      id,
      flightSearchInputRef
    } = this.props;
    let {
      flightText
    } = this.state;
    const flightResults = this.makeFlightTypeahead();
    const shouldShowResults = flightResults && this.haveFlights();
    const containerClass = (0, _classnames.default)({
      'open': shouldShowResults
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      className: containerClass,
      id: "flightSearch"
    }, /*#__PURE__*/_react.default.createElement("input", {
      ref: flightSearchInputRef,
      autoComplete: 'off',
      id: id,
      className: "form-control",
      name: name + '_text',
      type: "text",
      value: flightText,
      onClick: this.showDropdown,
      onBlur: this.blurDropdown,
      onFocus: this.showDropdown,
      placeholder: placeHolder,
      onKeyDown: this.handleKeyDown,
      onChange: this.handleChange
    }), shouldShowResults && flightResults, flightText && /*#__PURE__*/_react.default.createElement("span", {
      onClick: this.clearText,
      className: "btn-clear-flight"
    }, "x"));
  }
}
FlightTypeahead.propTypes = {
  name: _propTypes.string,
  activeFlight: _propTypes.string,
  placeHolder: _propTypes.string,
  cookieName: _propTypes.string,
  departure: (0, _propTypes.oneOfType)([_propTypes.number, (0, _propTypes.instanceOf)(Date)]),
  location: _propTypes.string,
  trackingPrefix: _propTypes.string,
  searchTimeout: _propTypes.number,
  minTextLimit: _propTypes.number,
  scrollResults: _propTypes.bool,
  autoFocus: _propTypes.bool,
  onChange: _propTypes.func,
  customChosenText: _propTypes.func,
  id: _propTypes.string,
  flightFieldInteraction: _propTypes.func
};
FlightTypeahead.defaultProps = {
  activeFlight: '',
  placeHolder: 'Search for flight',
  name: 'flight_number',
  cookieName: 'FlightNumber',
  searchTimeout: 300,
  // Default timeout before making search call
  minTextLimit: 2,
  // Min text length before making search
  trackingPrefix: 'flight_',
  autoFocus: false,
  scrollResults: true
};
var _default = exports.default = FlightTypeahead;


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-booking-forms-aps/lib/components/flight-lookup/flight-typeahead.js
// module id = 751
// module chunks = 119